var _defs, _polygon, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLoan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2.83 42.183 6.179 42.095 6.137 27.294 2.622 27.333 2.657 42.138 2.83 42.183"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.221,10.65c.214.215.77.475,1.075.513l14.118-.002c2.019-.216,2.132-2.908.227-3.404l-14.463-.01c-1.357.164-1.894,1.965-.957,2.904Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.414,3.574c-.129-.728-1.008-1.364-1.716-1.46-2.562-.349-5.825.243-8.464-.015-.716-.117-1.936.939-1.936,1.593v2.529s12.116,0,12.116,0c-.099-.796.134-1.893,0-2.647Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.428,29.498c.044.035.086.073.126.112l8.375,8.4c.089.089.166.189.23.298.274.468.441.967.505,1.469.965-.113,1.885-.271,2.73-.466,14.276-3.297,9.3-20.281.526-26.714h-13.125c-4.491,3.604-8.049,9.225-8.369,15.111,3.378.018,7.033.218,9.003,1.79Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.234,39.846c2.93.027,5.732-.45,8.447,1.036,2.178,1.191,2.976,3.391,5.296,4.358,1.317.549,2.7.663,4.109.707,5.663.178,11.41-.155,17.081-.068,2.41-.593,2.305-3.827-.233-4.167l-8.948-.006c-1.339,2.061-3.437,2.26-5.276.646-2.764-2.425-5.246-5.487-7.998-7.962-.442-.62.292-1.19.84-.705l8.139,8.099c1.905,1.584,4.438-.586,3.185-2.723l-8.375-8.4c-1.834-1.464-6.233-1.465-8.574-1.467-2.56-.003-5.129.178-7.682.328l-.011,10.324Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoan);
export default __webpack_public_path__ + "static/media/icon-loan.54f6fd28bf930468dcf219e0cc3d16a4.svg";
export { ForwardRef as ReactComponent };